import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class IdFormat extends ConfigNode
  @className = 'IdFormat'

  constructor: ->
    super('idFormat')

  @load: ->
    super('idFormat', @)

  getPrefix: ->
    @get('prefix')

  setPrefix: (val) ->
    @set('prefix', val)
    @save()

  resetPrefix: ->
    @setPrefix('')

  getIdType: ->
    @get('idType')

  setIdType: (val, params = {}) ->
    @set('idType', val)
    @save(params)

export default IdFormat
